import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCLX8tox5sJ-O_upiAViQ8nj_4ibQu2L2M",
  authDomain: "kamco-stage.firebaseapp.com",
  databaseURL: "https://kamco-stage-default-rtdb.firebaseio.com",
  projectId: "kamco-stage",
  storageBucket: "kamco-stage.firebasestorage.app",
  messagingSenderId: "867652920212",
  appId: "1:867652920212:web:3f10d4b03efebac12ce581",
  measurementId: "G-NMN9Y6STN6",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;
